/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSourcesCacheKeys } from "./constants";
import type { CDISource, CreateCDISource } from "./types";

export const postIntegrationsDirectCdiSources = reactQueryMutationAdapter(
  integrationsDirectCdiSourcesCacheKeys,
  (props: CreateCDISource): Promise<CDISource> => {
    return fetch("/integrations/direct/cdi/sources", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
